import {
    Box,
    Button,
    Checkbox,
    FormControl,
    FormLabel,
    Stack,
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { AddIcon, DeleteIcon } from '@chakra-ui/icons';
import usePipelineStore from '../../../../stores/pipeline-store';
import { DrawerInput, DrawerNumberInput, VarSelect } from '../inputs';

type GetAnswerValuesStepSettingsProps = {
    stepId: string;
};
export function GetAnswerValuesStepSettings({ stepId }: GetAnswerValuesStepSettingsProps) {
    const { pipeline, updateStep } = usePipelineStore((state) => state);
    const step = pipeline.steps[stepId] as GetAnswerValuesStep;
    return (
        <Box mx={-3}>
            <FormControl>
                <FormLabel>Survey Ref Var</FormLabel>
                <VarSelect
                    value={step.surveyRefVarId}
                    filterByType={['REF']}
                    onChange={(value) => updateStep(stepId, 'surveyRefVarId', value)}
                />
            </FormControl>

            <FormControl mt={2}>
                <FormLabel>Record Index</FormLabel>
                <DrawerNumberInput
                    min={0}
                    value={step.recordIndex ?? 0}
                    onChange={(_str, num) => updateStep(stepId, 'recordIndex', num)}
                />
            </FormControl>

            <FormControl mt={2}>
                <FormLabel>Requested answers</FormLabel>
                <Stack>
                    <TableContainer>
                        <Table variant={'unstyled'}>
                            <Thead>
                                <Tr>
                                    <Th textAlign={'center'} padding={'0 !important'}>
                                        Is from var
                                    </Th>
                                    <Th textAlign={'center'} padding={'0 !important'}>
                                        Source
                                    </Th>
                                    <Th textAlign={'center'} padding={'0 !important'}>
                                        Destination
                                    </Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {step.requestedData.map((paramElem, index) => {
                                    return (
                                        <Tr>
                                            <Td textAlign={'center'} padding={'0 !important'}>
                                                <Checkbox
                                                    isChecked={paramElem.keyIsFromVar}
                                                    onChange={({ target: { checked } }: any) => {
                                                        let requestedData = JSON.parse(
                                                            JSON.stringify(step.requestedData),
                                                        );
                                                        requestedData[index].keyIsFromVar = checked;
                                                        updateStep(stepId, 'requestedData', requestedData);
                                                    }}
                                                />
                                            </Td>
                                            <Td padding={'0 !important'}>
                                                {paramElem.keyIsFromVar ? (
                                                    <VarSelect
                                                        value={paramElem.keyVarId}
                                                        placeholder="Source"
                                                        filterByType={['STRING']}
                                                        onChange={(value) => {
                                                            const requestedData = JSON.parse(
                                                                JSON.stringify(step.requestedData),
                                                            );
                                                            requestedData[index].keyVarId = value;
                                                            updateStep(stepId, 'requestedData', requestedData);
                                                        }}
                                                    />
                                                ) : (
                                                    <DrawerInput
                                                        placeholder="Key in record"
                                                        value={paramElem.key}
                                                        onChange={(e) => {
                                                            const requestedData = JSON.parse(
                                                                JSON.stringify(step.requestedData),
                                                            );
                                                            requestedData[index].key = e.target.value;
                                                            updateStep(stepId, 'requestedData', requestedData);
                                                        }}
                                                    />
                                                )}
                                            </Td>
                                            <Td
                                                paddingTop={'0 !important'}
                                                paddingBottom={'0 !important'}
                                                paddingEnd={'0 !important'}
                                            >
                                                <VarSelect
                                                    value={paramElem.targetVarId}
                                                    placeholder="Destination"
                                                    filterByType={['STRING', 'NUMBER', 'BOOLEAN']}
                                                    onChange={(value) => {
                                                        const requestedData = JSON.parse(
                                                            JSON.stringify(step.requestedData),
                                                        );
                                                        requestedData[index].targetVarId = value;
                                                        updateStep(stepId, 'requestedData', requestedData);
                                                    }}
                                                />
                                            </Td>
                                            <Td>
                                                <Button
                                                    backgroundColor="white"
                                                    _hover={{ color: '#f0706e' }}
                                                    _focus={{ backgroundColor: 'white' }}
                                                    _active={{ backgroundColor: 'white' }}
                                                    color={'grey'}
                                                    leftIcon={<DeleteIcon />}
                                                    onClick={() => {
                                                        let requestedData = JSON.parse(
                                                            JSON.stringify(step.requestedData),
                                                        );
                                                        requestedData.splice(index, 1);
                                                        updateStep(stepId, 'requestedData', requestedData);
                                                    }}
                                                ></Button>
                                            </Td>
                                        </Tr>
                                    );
                                })}
                            </Tbody>
                        </Table>
                    </TableContainer>
                    <Button
                        backgroundColor="white"
                        fontSize={'sm'}
                        _hover={{ backgroundColor: 'white', color: 'black' }}
                        _focus={{ backgroundColor: 'white' }}
                        _active={{ backgroundColor: 'white' }}
                        color={'grey'}
                        leftIcon={<AddIcon />}
                        onClick={() => {
                            let requestedData = JSON.parse(JSON.stringify(step.requestedData));
                            requestedData.push({
                                key: '',
                                targetVarId: '',
                                keyIsFromVar: false,
                                keyVarId: '',
                            });
                            updateStep(stepId, 'requestedData', requestedData);
                        }}
                    >
                        Add Answer Request
                    </Button>
                </Stack>
            </FormControl>
        </Box>
    );
}
